
module.exports = () ->
  pseudoTime = 0
  () ->
    ++pseudoTime
